<div class="avatar-container">
  <div class="avatar-wrapper">
    <ng-content class="avatar"></ng-content>
  </div>
  @if (!!badge) {
    <ca-image-loader
      [matTooltip]="!!badge ? badge.name : null"
      [matTooltipPosition]="'right'"
      class="badgeImage"
      fit="contain"
      [showPlaceholder]="false"
      [image]="{ id: badge.fileId } | filedownloadurl | async"
    ></ca-image-loader>
  }
</div>
